import script from "./Courses.vue?vue&type=script&setup=true&lang=js"
export * from "./Courses.vue?vue&type=script&setup=true&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=51c7ef9c&scoped=true&lang=css"

import exportComponent from "/var/www/almustafa-laravel-live/releases/20261104161609/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c7ef9c"]])

export default __exports__